import { render, staticRenderFns } from "./CompaniesKanban.container.vue?vue&type=template&id=27f4f35a&scoped=true&"
import script from "./CompaniesKanban.container.vue?vue&type=script&lang=ts&"
export * from "./CompaniesKanban.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4f35a",
  null
  
)

export default component.exports